// Плашка «не хватает токенов» под платной кнопкой — одна на весь сайт (21 место). Владелец 11.10 (вариант А): вместо
// оранжевой строки со ссылкой — сколько не хватает и кнопка «Пополнить», которая открывает пополнение поверх страницы.
// Владелец 13.10: докупка открыта всем, и без оплаченного периода тоже (сервер такую докупку принимает — лот без
// подписки живёт 30 дней); тарифы остаются в шапке и в кабинете. Набранное и настройки остаются: после оплаты окно
// докупки сразу перечитывает баланс, а «Готово» не уводит в кабинет, — плашка уходит вместе с запретом кнопки.
import { useContext, useState, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { AuthContext } from '../context/AuthContext'
import { Coin } from '../icons/Coin'
import TopUpSlider from '../pages/account/components/TopUpSlider'
import { fmtTokens, missingTokens } from '../utils/credits'
import { openTopUp } from '../utils/topUpRequest'

interface Props {
	/** Цена запуска — плашка пишет, сколько до неё не хватает. Не передана — без суммы. */
	price?: number | null
	/** Баланс, если место считает его само (оценка сервера в Мастерской); иначе — баланс профиля. */
	balance?: number | null
	/** Цена «от» (итог по факту): не хватает даже на минимальную. */
	from?: boolean
	className?: string
}

export default function CreditsShortNote({ price, balance, from = false, className }: Props) {
	const user = useContext(AuthContext)?.user ?? null
	const have = balance ?? Number(user?.credits_balance ?? 0)
	const p = Number(price)
	const missing = price != null && Number.isFinite(p) ? missingTokens(p, have) : 0
	const tail = from ? 'даже на минимальную цену' : 'на этот запуск'

	return (
		<p className={`credits-short${className ? ` ${className}` : ''}`} role="status">
			<span className="credits-short__text">
				{missing > 0 ? (
					<>Не хватает <b className="credits-short__sum">{fmtTokens(missing)}<Coin size={13} /></b> {tail}</>
				) : (
					`Не хватает токенов ${tail}`
				)}
			</span>
			<TopUpButton />
		</p>
	)
}

/** «Пополнить» → окно «Докупить токены» поверх страницы. need — сколько токенов не хватает: ползунок сразу встаёт на
 *  сумму под них (остаток ответа чата, владелец 13.10); без него — сумма по умолчанию из админки. Нехватка снимается в
 *  момент нажатия: баланс, перечитанный за время оплаты, не сдвигает сумму в открытом окне. Окно — общее (TopUpHost в
 *  App): кнопка исчезает, как только баланса хватило, а окно с «Оплата получена» остаётся; без хоста — своё окно. */
export function TopUpButton({ need = 0, className = 'credits-short__btn', children = 'Пополнить' }: {
	need?: number
	className?: string
	children?: ReactNode
}) {
	const [openNeed, setOpenNeed] = useState<number | null>(null)
	return (
		<>
			<button type="button" className={className} onClick={() => { if (!openTopUp(need)) setOpenNeed(need) }}>{children}</button>
			{/* Окно докупки — порталом в body и слоем выше шторок: плашка живёт и внутри шторок (Suno, фотостудия,
			    помощники), а у окна свой слой 1000 — под шторкой (10000) его бы не было видно */}
			{openNeed !== null && createPortal(
				<div className="credits-short__layer"><TopUpSlider open stayOnPage needTokens={openNeed} onClose={() => setOpenNeed(null)} /></div>,
				document.body,
			)}
		</>
	)
}
